export const SELECTED_TEST = "SELECTED_TEST";
export const SET_RESULTS = "SET_RESULTS";
